module.exports = __webpack_public_path__ + "img/imgYLSYB(16).1c3bdd7e.png";